// extracted by mini-css-extract-plugin
export default {"wrapper":"zo-z","response":"Ao-z","error":"Bo-z","disabled":"Co-z","buttons":"Do-z","feedbackQuestionSection":"Eo-z","yesNoWrapper":"Fo-z"};